export var SchemaType;
(function (SchemaType) {
    SchemaType[SchemaType["Normal"] = 0] = "Normal";
    SchemaType[SchemaType["Indivisible"] = 1] = "Indivisible";
})(SchemaType || (SchemaType = {}));
export var Lang;
(function (Lang) {
    Lang["Raw"] = "raw";
    Lang["Javascript"] = "javascript";
    Lang["Html"] = "html";
    Lang["Json"] = "json";
})(Lang || (Lang = {}));
export const getFieldName = (nameGetter, anyGet) => {
    if (!nameGetter) {
        return;
    }
    if (typeof nameGetter === 'string') {
        return nameGetter;
    }
    return nameGetter(anyGet);
};
export var FieldType;
(function (FieldType) {
    FieldType[FieldType["Normal"] = 0] = "Normal";
    FieldType[FieldType["Array"] = 1] = "Array";
    FieldType[FieldType["DynamicObject"] = 2] = "DynamicObject";
    FieldType[FieldType["TreeObject"] = 3] = "TreeObject";
    FieldType[FieldType["Indivisible"] = 4] = "Indivisible";
})(FieldType || (FieldType = {}));
